import { render, staticRenderFns } from "./RefreshButton.vue?vue&type=template&id=1a477935"
import script from "./RefreshButton.vue?vue&type=script&lang=ts"
export * from "./RefreshButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a477935')) {
      api.createRecord('1a477935', component.options)
    } else {
      api.reload('1a477935', component.options)
    }
    module.hot.accept("./RefreshButton.vue?vue&type=template&id=1a477935", function () {
      api.rerender('1a477935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generic/RefreshButton.vue"
export default component.exports